

export const WordTitle = (word: string | null | undefined): string => {
    if (word) {
        return word[0].toUpperCase() + word.slice(1).toLowerCase();
    }
    return "";
}

export const prettifyLabel = (label: string): string => {
    const prettifiedLabel = label
    .replace(/[-_]/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());
    return prettifiedLabel;
}

export const USANameFormat = (firstName: string | null | undefined,
     lastName: string | null | undefined): string => {
    if (!firstName || !lastName) {
        return "";
    } else if (firstName && lastName) {
        return `${WordTitle(lastName)}, ${WordTitle(firstName)}`;
    } else {
        return WordTitle(lastName) || WordTitle(firstName);
    }
}
